/**
 * The bare-domain page (no token). Referees always arrive at /r/:token from their email or a
 * shared message; anyone hitting the root gets a calm one-liner rather than a blank screen.
 */
import { ThreadMark } from '@/components/ThreadMark';

export function RootNotice() {
  return (
    <div className="referee-shell flex min-h-svh flex-col items-center justify-center px-6 text-center">
      <ThreadMark className="h-[22px] w-auto" />
      <h1 className="mt-5 font-display text-[22px] font-semibold tracking-[-0.02em] text-ink">
        By My Word
      </h1>
      <p className="mt-2 max-w-[32ch] font-body text-[13.5px] leading-relaxed text-ink-70">
        Open the link from your email or message to give your word.
      </p>
    </div>
  );
}
